import LayoutView from './layout_view';

export default LayoutView;
